import React from "react";
import Buttons from "../components/Buttons";
import Mouse from "../components/Mouse";
import Navigation from "../components/Navigation";
import Project from "../components/Project";

const Project7 = () => {
  return (
    <div>
      <main>
        <Mouse />
        <div className="project">
          <Navigation />
          <Project projectNumber={6} />
          <Buttons left={"/projet-6"} right={"/contact"} />
        </div>
      </main>
    </div>
  );
};

export default Project7;